import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=1128054b&"
import script from "./ChatMessages.vue?vue&type=script&lang=ts&"
export * from "./ChatMessages.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessages.vue?vue&type=style&index=0&id=1128054b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports